module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-nav-item-dropdown', {
    attrs: {
      "text": "For Authors"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'forAuthorsSubmissionGuidelines'
        })
      }
    }
  }, [_vm._v("Submission Guidelines")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'forAuthorsStyleGuidelines'
        })
      }
    }
  }, [_vm._v("Style Guidelines")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'forAuthorsPolicies'
        })
      }
    }
  }, [_vm._v("Policies")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-496b0c42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/header-nav/dropdowns/ForAuthorsDropdownComponent.vue
// module id = 1426
// module chunks = 1